import React, {useEffect, useState} from 'react';
import {deleteUnPaidSponsorshipFromCart} from '../../../Store/Actions';
import {useDispatch, useSelector} from 'react-redux';
import SponsorshipOptionComponent from '../../../Components/UserComponents/SponsorshipOption';
import {getEventOptionsByEventId} from '../../../Store/Actions/eventOptions';
import {getRegistrationUserWaitingListById} from '../../../Store/Actions/eventRegister';
import {isActiveWaitingListEntry} from '../../../Util/commonUtility';
import {useParams} from 'react-router-dom';

const SponsorshipOptionContainer = () => {
  const {id} = useParams();
  const dispatch = useDispatch();
  const [allEventOptionsRegistrationData, setAllEventOptionsRegistrationData] =
    useState([]);
  const [eventLocalChapterData, setEventLocalChapterData] = useState();
  const {getEventOptionByEventId} = useSelector(
    ({eventOptions}) => eventOptions,
  );
  const {allUserRegistrationWaitingList} = useSelector(
    ({eventRegister}) => eventRegister,
  );
  const allChapters = useSelector((state) => state.chapters.allChapters);
  const userID = JSON.parse(localStorage.getItem('userInfo'))?.id;
  const [allSponsorshipWaitingList, setAllSponsorshipWaitingList] = useState(
    [],
  );

  useEffect(() => {
    if (
      getEventOptionByEventId?.data?.sponsorship?.length > 0
        ? parseInt(id) ===
          getEventOptionByEventId?.data?.sponsorship[0]?.event_id
        : getEventOptionByEventId
    ) {
      const filteredSponsorData = getEventOptionByEventId?.data?.sponsorship;
      const eventLocalChapterData = allChapters?.data?.chapters?.find(
        (obj) => obj.id === getEventOptionByEventId?.data?.local_chapter_id,
      );
      setEventLocalChapterData(eventLocalChapterData);
      setAllEventOptionsRegistrationData(filteredSponsorData);
    } else {
      dispatch(getEventOptionsByEventId(id));
    }
  }, [getEventOptionByEventId]);

  const fetchWaitingList = async (eventId) => {
    try {
      dispatch(getRegistrationUserWaitingListById(eventId, userID));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (allUserRegistrationWaitingList) {
      const waitingList = Array.isArray(
        allUserRegistrationWaitingList?.waitingList,
      )
        ? allUserRegistrationWaitingList.waitingList
        : [];
      setAllSponsorshipWaitingList(
        waitingList.filter(
          (item) =>
            isActiveWaitingListEntry(item) &&
            (item?.registration_type || '').toString().toLowerCase() ===
              'sponsorship',
        ),
      );
    } else if (id) {
      fetchWaitingList(id);
    }
  }, [allUserRegistrationWaitingList?.waitingList, id]);

  useEffect(() => {
    if (id) fetchWaitingList(id);
  }, [id]);

  const getEventSponsorOptions = (id) => {
    dispatch(getEventOptionsByEventId(id));
  };
  const removeSponsorShipFromCart = (eventId) => {
    dispatch(deleteUnPaidSponsorshipFromCart(eventId));
  };

  return (
    <SponsorshipOptionComponent
      allEventOptionsRegistrationData={allEventOptionsRegistrationData}
      getEventSponsorOptions={(id) => {
        getEventSponsorOptions(id);
      }}
      removeSponsorShipFromCart={(eventId) => {
        removeSponsorShipFromCart(eventId);
      }}
      eventLocalChapterData={eventLocalChapterData}
      eventName={getEventOptionByEventId?.data?.event_name}
      waitingListData={allSponsorshipWaitingList}
    />
  );
};

export default SponsorshipOptionContainer;
